import "./App.scss"

import { Route, Routes } from "react-router-dom"

import InitialData from "./appData/initialData"
import { AppStateProvider } from "./context/appStateContext"
import { BlackFridayProvider } from "./context/blackFridayContext"
import ConditionalFreeTrialPaywall from "./pages/ConditionalFreeTrialPaywall/ConditionalFreeTrialPaywall"
import ConditionalUltimatePaywall from "./pages/ConditionalUltimatePaywall/ConditionalUltimatePaywall"
import DefaultPaywall from "./pages/DefaultPaywall/DefaultPaywall"
import ExpirationPaywall from "./pages/ExpirationPaywall/ExpirationPaywall"
import LimitedTimePaywall from "./pages/LimitedTimePaywall/LimitedTimePaywall"
import PageList from "./pages/PageList"
import PromoBanner from "./pages/PromoPaywall/PromoBanner/PromoBanner"
import PromoPaywall from "./pages/PromoPaywall/PromoPaywall"
import createStyleConfig from "./styleConfig"
import SafeAreaInsetPage from "./components/SafeAreaInsetPage/SafeAreaInsetPage"
import SpecialOfferPaywall from "./pages/SpecialOfferPaywall/SpecialOfferPaywall"
import { ExpirationProvider } from "./context/expirationContext"
import ExpirationModernPaywall from "./pages/ExpirationModernPaywall/ExpirationModernPaywall"
import AnimatedPaywall from "./pages/AnimatedPaywall/AnimatedPaywall"
import MultiStepPaywall from "./pages/MultiStepPaywall/MultiStepPaywall"
import FreeTrialPaywall from "./pages/FreeTrialPaywall/FreeTrialPaywall"
import TAPaywall from "./pages/TAPaywall/TAPaywall"
import SummerBanner from "./pages/SummerPaywall/SummerBanner/SummerBanner"
import SummerPaywall from "./pages/SummerPaywall/SummerPaywall"
import BubbleExpirationPaywall from "./pages/BubbleExpirationPaywall/BubbleExpirationPaywall"
import EmailPromoPaywall from "./pages/EmailPromoPaywall/EmailPromoPaywall"
import HalloweenPaywall from "./pages/HalloweenPaywall/HalloweenPaywall"
import HalloweenBanner from "./pages/HalloweenPaywall/HalloweenBanner"
import AutumnPaywall from "./pages/AutumnPaywall/AutumnPaywall"
import AutumnBanner from "./pages/AutumnPaywall/AutumnBanner/AutumnBanner"
import WinterPaywall from "./pages/WinterPaywall/WinterPaywall"
import WinterBanner from "./pages/WinterPaywall/WinterBanner/WinterBanner"
import SpringPaywall from "./pages/SpringPaywall/SpringPaywall"
import SpringBanner from "./pages/SpringPaywall/SpringBanner/SpringBanner"
import OnboardingUltimateAlternatePaywall from "./pages/OnboardingUltimateAlternatePaywall/OnboardingUltimateAlternatePaywall"
import BlackFriday2025Paywall from "./pages/BlackFriday2025Paywall/BlackFriday2025Paywall"
import BlackFriday2025Banner from "./pages/BlackFriday2025Paywall/BlackFriday2025Banner/BlackFriday2025Banner"
import BlackFridayNoFeaturesPaywall from "./pages/BlackFridayNoFeaturesPaywall/BlackFridayNoFeaturesPaywall"
import CyberMonday2025Paywall from "./pages/CyberMonday2025Paywall/CyberMonday2025Paywall"
import CyberMonday2025Banner from "./pages/CyberMonday2025Paywall/CyberMonday2025Banner/CyberMonday2025Banner"
import TabsPaywall from "./pages/TabsPaywall/TabsPaywall"
import ThreeStepPaywall from "./pages/ThreeStepPaywall/ThreeStepPaywall"
import BackupPaywall from "./pages/BackupPaywall/BackupPaywall"
import OneStepExpirationPaywall from "./pages/OneStepExpirationPaywall/OneStepExpirationPaywall"
import SocialProofPaywall from "./pages/SocialProofPaywall/SocialProofPaywall"
import YearlyOnlyAppStorePaywall from "./pages/YearlyOnlyAppStorePaywall/YearlyOnlyAppStorePaywall"
import ImportPhotosScreen from "./pages/ImportPhotosScreen/ImportPhotosScreen"
import LossAversionPaywall from "./pages/LossAversionPaywall/LossAversionPaywall"
import AuroraVaultPaywall from "./pages/AuroraVaultPaywall/AuroraVaultPaywall"
import BreakInPaywall from "./pages/BreakInPaywall/BreakInPaywall"
import DeepFreezePaywall from "./pages/DeepFreezePaywall/DeepFreezePaywall"
import KeyholderPaywall from "./pages/KeyholderPaywall/KeyholderPaywall"
import VaultWrappedPaywall from "./pages/VaultWrappedPaywall/VaultWrappedPaywall"
import AbyssPaywall from "./pages/AbyssPaywall/AbyssPaywall"
import VaultDoorPaywall from "./pages/VaultDoorPaywall/VaultDoorPaywall"
import DecoyPaywall from "./pages/DecoyPaywall/DecoyPaywall"
import RecallPaywall from "./pages/RecallPaywall/RecallPaywall"
import FeatherweightPaywall from "./pages/FeatherweightPaywall/FeatherweightPaywall"
import ReclaimedPaywall from "./pages/ReclaimedPaywall/ReclaimedPaywall"
import KindredPaywall from "./pages/KindredPaywall/KindredPaywall"
import ReceiptPaywall from "./pages/ReceiptPaywall/ReceiptPaywall"
import TidyPaywall from "./pages/TidyPaywall/TidyPaywall"
import AtlasPaywall from "./pages/AtlasPaywall/AtlasPaywall"
import OriginalPaywall from "./pages/OriginalPaywall/OriginalPaywall"
import BoundPaywall from "./pages/BoundPaywall/BoundPaywall"
import EverywherePaywall from "./pages/EverywherePaywall/EverywherePaywall"
import RewindPaywall from "./pages/RewindPaywall/RewindPaywall"
import EncorePaywall from "./pages/EncorePaywall/EncorePaywall"
import RetouchPaywall from "./pages/RetouchPaywall/RetouchPaywall"
import HeirloomPaywall from "./pages/HeirloomPaywall/HeirloomPaywall"
import PrismPaywall from "./pages/PrismPaywall/PrismPaywall"
import NimbusPaywall from "./pages/NimbusPaywall/NimbusPaywall"
import EnclavePaywall from "./pages/EnclavePaywall/EnclavePaywall"
import ThresholdPaywall from "./pages/ThresholdPaywall/ThresholdPaywall"
import UnbrokenPaywall from "./pages/UnbrokenPaywall/UnbrokenPaywall"
import AheadPaywall from "./pages/AheadPaywall/AheadPaywall"
import ReflexPaywall from "./pages/ReflexPaywall/ReflexPaywall"
import KeptPaywall from "./pages/KeptPaywall/KeptPaywall"
import SlipstreamPaywall from "./pages/SlipstreamPaywall/SlipstreamPaywall"
import SafetyNetPaywall from "./pages/SafetyNetPaywall/SafetyNetPaywall"
import ByHeartPaywall from "./pages/ByHeartPaywall/ByHeartPaywall"
import KeystonePaywall from "./pages/KeystonePaywall/KeystonePaywall"
import LongviewPaywall from "./pages/LongviewPaywall/LongviewPaywall"
import CounterweightPaywall from "./pages/CounterweightPaywall/CounterweightPaywall"
import KeepPostedPaywall from "./pages/KeepPostedPaywall/KeepPostedPaywall"
import PatchworkPaywall from "./pages/PatchworkPaywall/PatchworkPaywall"
import EvergreenPaywall from "./pages/EvergreenPaywall/EvergreenPaywall"
import KeepsakePaywall from "./pages/KeepsakePaywall/KeepsakePaywall"
import GlyphPaywall from "./pages/GlyphPaywall/GlyphPaywall"
import OverairPaywall from "./pages/OverairPaywall/OverairPaywall"
import ProofPaywall from "./pages/ProofPaywall/ProofPaywall"
import BeaconPaywall from "./pages/BeaconPaywall/BeaconPaywall"
import MainspringPaywall from "./pages/MainspringPaywall/MainspringPaywall"
import AmberPaywall from "./pages/AmberPaywall/AmberPaywall"
import SightlinePaywall from "./pages/SightlinePaywall/SightlinePaywall"
import PostmarkPaywall from "./pages/PostmarkPaywall/PostmarkPaywall"
import FirstlightPaywall from "./pages/FirstlightPaywall/FirstlightPaywall"
import CloserPaywall from "./pages/CloserPaywall/CloserPaywall"
import CascadePaywall from "./pages/CascadePaywall/CascadePaywall"
import TearlinePaywall from "./pages/TearlinePaywall/TearlinePaywall"
import HandselPaywall from "./pages/HandselPaywall/HandselPaywall"
import DoublesPaywall from "./pages/DoublesPaywall/DoublesPaywall"
import HomecomingPaywall from "./pages/HomecomingPaywall/HomecomingPaywall"
import OpenShutterPaywall from "./pages/OpenShutterPaywall/OpenShutterPaywall"
import FullCirclePaywall from "./pages/FullCirclePaywall/FullCirclePaywall"
import OffscreenPaywall from "./pages/OffscreenPaywall/OffscreenPaywall"
import FailsafePaywall from "./pages/FailsafePaywall/FailsafePaywall"
import CarryallPaywall from "./pages/CarryallPaywall/CarryallPaywall"
import StandbyPaywall from "./pages/StandbyPaywall/StandbyPaywall"
import PerimeterPaywall from "./pages/PerimeterPaywall/PerimeterPaywall"
import TidelinePaywall from "./pages/TidelinePaywall/TidelinePaywall"
import OncePaywall from "./pages/OncePaywall/OncePaywall"
import HearthPaywall from "./pages/HearthPaywall/HearthPaywall"
import HeadroomPaywall from "./pages/HeadroomPaywall/HeadroomPaywall"
import ReelPaywall from "./pages/ReelPaywall/ReelPaywall"
import TrovePaywall from "./pages/TrovePaywall/TrovePaywall"
import VistaPaywall from "./pages/VistaPaywall/VistaPaywall"
import TumblerPaywall from "./pages/TumblerPaywall/TumblerPaywall"
import LifelinePaywall from "./pages/LifelinePaywall/LifelinePaywall"
import ArtifactPaywall from "./pages/ArtifactPaywall/ArtifactPaywall"
import BrinkPaywall from "./pages/BrinkPaywall/BrinkPaywall"
import AegisPaywall from "./pages/AegisPaywall/AegisPaywall"
import VigilPaywall from "./pages/VigilPaywall/VigilPaywall"
import ThroughlinePaywall from "./pages/ThroughlinePaywall/ThroughlinePaywall"
import StickerAlbumPaywall from "./pages/StickerAlbumPaywall/StickerAlbumPaywall"
import FlurryPaywall from "./pages/FlurryPaywall/FlurryPaywall"
import CurrentPaywall from "./pages/CurrentPaywall/CurrentPaywall"
import ImprintPaywall from "./pages/ImprintPaywall/ImprintPaywall"
import PlainSightPaywall from "./pages/PlainSightPaywall/PlainSightPaywall"
import CipherPaywall from "./pages/CipherPaywall/CipherPaywall"
import OnlyYouPaywall from "./pages/OnlyYouPaywall/OnlyYouPaywall"
import HallmarkPaywall from "./pages/HallmarkPaywall/HallmarkPaywall"
import WardPaywall from "./pages/WardPaywall/WardPaywall"
import RekindlePaywall from "./pages/RekindlePaywall/RekindlePaywall"
import StaticPaywall from "./pages/StaticPaywall/StaticPaywall"
import EyesOnlyPaywall from "./pages/EyesOnlyPaywall/EyesOnlyPaywall"
import SafelightPaywall from "./pages/SafelightPaywall/SafelightPaywall"
import SanctumPaywall from "./pages/SanctumPaywall/SanctumPaywall"
import BystanderPaywall from "./pages/BystanderPaywall/BystanderPaywall"
import KeylinePaywall from "./pages/KeylinePaywall/KeylinePaywall"
import SeamPaywall from "./pages/SeamPaywall/SeamPaywall"
import FlipsidePaywall from "./pages/FlipsidePaywall/FlipsidePaywall"
import NightlatchPaywall from "./pages/NightlatchPaywall/NightlatchPaywall"
import FoldPaywall from "./pages/FoldPaywall/FoldPaywall"
import AperturePaywall from "./pages/AperturePaywall/AperturePaywall"
import FacedownPaywall from "./pages/FacedownPaywall/FacedownPaywall"
import StrongboxPaywall from "./pages/StrongboxPaywall/StrongboxPaywall"
import TracePaywall from "./pages/TracePaywall/TracePaywall"
import LatentPaywall from "./pages/LatentPaywall/LatentPaywall"
import WatermarkPaywall from "./pages/WatermarkPaywall/WatermarkPaywall"
import ShadePaywall from "./pages/ShadePaywall/ShadePaywall"
import ReissuePaywall from "./pages/ReissuePaywall/ReissuePaywall"
import ClaspPaywall from "./pages/ClaspPaywall/ClaspPaywall"
import SentryPaywall from "./pages/SentryPaywall/SentryPaywall"
import UnseenPaywall from "./pages/UnseenPaywall/UnseenPaywall"
import TwofoldPaywall from "./pages/TwofoldPaywall/TwofoldPaywall"
import HandoffPaywall from "./pages/HandoffPaywall/HandoffPaywall"
import SealedPaywall from "./pages/SealedPaywall/SealedPaywall"
import ClearedPaywall from "./pages/ClearedPaywall/ClearedPaywall"
import NegativePaywall from "./pages/NegativePaywall/NegativePaywall"
import InkPaywall from "./pages/InkPaywall/InkPaywall"
import BothKeysPaywall from "./pages/BothKeysPaywall/BothKeysPaywall"
import LodestonePaywall from "./pages/LodestonePaywall/LodestonePaywall"
import MantlePaywall from "./pages/MantlePaywall/MantlePaywall"
import SilveredPaywall from "./pages/SilveredPaywall/SilveredPaywall"
import AirtightPaywall from "./pages/AirtightPaywall/AirtightPaywall"
import CradlePaywall from "./pages/CradlePaywall/CradlePaywall"
import ReinstatePaywall from "./pages/ReinstatePaywall/ReinstatePaywall"
import IroncladPaywall from "./pages/IroncladPaywall/IroncladPaywall"
import YoursPaywall from "./pages/YoursPaywall/YoursPaywall"
import EclipsePaywall from "./pages/EclipsePaywall/EclipsePaywall"
import TemperedPaywall from "./pages/TemperedPaywall/TemperedPaywall"
import SignetPaywall from "./pages/SignetPaywall/SignetPaywall"
import TraceryPaywall from "./pages/TraceryPaywall/TraceryPaywall"
import EntrustPaywall from "./pages/EntrustPaywall/EntrustPaywall"
import TuckPaywall from "./pages/TuckPaywall/TuckPaywall"
import LanternPaywall from "./pages/LanternPaywall/LanternPaywall"
import LocketPaywall from "./pages/LocketPaywall/LocketPaywall"
import HaloPaywall from "./pages/HaloPaywall/HaloPaywall"
import SolariPaywall from "./pages/SolariPaywall/SolariPaywall"
import EverwatchPaywall from "./pages/EverwatchPaywall/EverwatchPaywall"
import HoldfastPaywall from "./pages/HoldfastPaywall/HoldfastPaywall"
import LonghandPaywall from "./pages/LonghandPaywall/LonghandPaywall"

let preReactInitialData: InitialData | undefined = undefined

function initialDataLoad(data: InitialData) {
  preReactInitialData = data
}

;(window as any).initialDataLoad = initialDataLoad

const App = () => {
  return (
    <AppStateProvider
      sendAllProductData={false}
      isPromo={false}
      styleConfigCreator={createStyleConfig}
    >
      <BlackFridayProvider>
        <ExpirationProvider>
          <AppContent />
        </ExpirationProvider>
      </BlackFridayProvider>
    </AppStateProvider>
  )
}

function AppContent() {
  return (
    <SafeAreaInsetPage>
      <Routes>
        <Route path="/" element={<PageList />}></Route>
        <Route
          path="/freetrialpaywall"
          element={
            <ConditionalFreeTrialPaywall freeTrialPaywall={FreeTrialPaywall} />
          }
        />
        <Route
          path="/ultimatepaywall"
          element={<ConditionalUltimatePaywall />}
        />
        <Route path="/limitedtimepaywall" element={<LimitedTimePaywall />} />
        <Route path="/promo" element={<PromoPaywall />} />
        <Route path="/promo/banner" element={<PromoBanner />} />
        <Route path="/blackFriday" element={<PromoPaywall />} />
        <Route path="/blackFriday/banner" element={<PromoBanner />} />
        <Route path="/expiration" element={<ExpirationPaywall />} />
        <Route path="/expirationModern" element={<ExpirationModernPaywall />} />
        <Route path="/default" element={<DefaultPaywall />} />
        <Route path="/specialOffer" element={<SpecialOfferPaywall />} />
        <Route path="/animatedPaywall" element={<AnimatedPaywall />} />
        <Route path="/multiStep" element={<MultiStepPaywall />} />
        <Route path="/taPaywall" element={<TAPaywall />} />
        <Route path="/promoSummer" element={<SummerPaywall />} />
        <Route path="/promoSummer/banner" element={<SummerBanner />} />
        <Route path="/promoHalloween" element={<HalloweenPaywall />} />
        <Route path="/promoHalloween/banner" element={<HalloweenBanner />} />
        <Route path="/promoAutumn" element={<AutumnPaywall />} />
        <Route path="/promoAutumn/banner" element={<AutumnBanner />} />
        <Route path="/promoWinter" element={<WinterPaywall />} />
        <Route path="/promoWinter/banner" element={<WinterBanner />} />
        <Route path="/promoSpring" element={<SpringPaywall />} />
        <Route path="/promoSpring/banner" element={<SpringBanner />} />
        <Route
          path="/promoBlackFriday2025"
          element={<BlackFriday2025Paywall />}
        />
        <Route
          path="/promoBlackFriday2025/banner"
          element={<BlackFriday2025Banner />}
        />
        <Route
          path="/promoBlackFridayNoFeatures"
          element={<BlackFridayNoFeaturesPaywall />}
        />
        <Route
          path="/promoCyberMonday2025"
          element={<CyberMonday2025Paywall />}
        />
        <Route
          path="/promoCyberMonday2025/banner"
          element={<CyberMonday2025Banner />}
        />
        <Route path="/bubbleExpiration" element={<BubbleExpirationPaywall />} />
        <Route path="/expirationGridPaywall" element={<ThreeStepPaywall />} />
        <Route path="/tabsPaywall" element={<TabsPaywall />} />
        <Route path="/backupPaywall" element={<BackupPaywall />} />
        <Route path="/emailPromo" element={<EmailPromoPaywall />} />
        <Route
          path="/oneStepExpiration"
          element={<OneStepExpirationPaywall />}
        />
        <Route path="/socialProof" element={<SocialProofPaywall />} />
        <Route
          path="/yearlyOnlyAppstore"
          element={<YearlyOnlyAppStorePaywall />}
        />
        <Route path="/importPhotos" element={<ImportPhotosScreen />} />
        <Route path="/lossAversion" element={<LossAversionPaywall />} />
        <Route path="/auroraVault" element={<AuroraVaultPaywall />} />
        <Route path="/caught" element={<BreakInPaywall />} />
        <Route path="/deepFreeze" element={<DeepFreezePaywall />} />
        <Route path="/keyholder" element={<KeyholderPaywall />} />
        <Route path="/vaultWrapped" element={<VaultWrappedPaywall />} />
        <Route path="/abyss" element={<AbyssPaywall />} />
        <Route path="/vaultDoor" element={<VaultDoorPaywall />} />
        <Route path="/decoy" element={<DecoyPaywall />} />
        <Route path="/recall" element={<RecallPaywall />} />
        <Route path="/featherweight" element={<FeatherweightPaywall />} />
        <Route path="/kindred" element={<KindredPaywall />} />
        <Route path="/receipt" element={<ReceiptPaywall />} />
        <Route path="/tidy" element={<TidyPaywall />} />
        <Route path="/reclaimed" element={<ReclaimedPaywall />} />
        <Route path="/atlas" element={<AtlasPaywall />} />
        <Route path="/original" element={<OriginalPaywall />} />
        <Route path="/bound" element={<BoundPaywall />} />
        <Route path="/everywhere" element={<EverywherePaywall />} />
        <Route path="/rewind" element={<RewindPaywall />} />
        <Route path="/encore" element={<EncorePaywall />} />
        <Route path="/retouch" element={<RetouchPaywall />} />
        <Route path="/heirloom" element={<HeirloomPaywall />} />
        <Route path="/prism" element={<PrismPaywall />} />
        <Route path="/nimbus" element={<NimbusPaywall />} />
        <Route path="/enclave" element={<EnclavePaywall />} />
        <Route path="/threshold" element={<ThresholdPaywall />} />
        <Route path="/unbroken" element={<UnbrokenPaywall />} />
        <Route path="/ahead" element={<AheadPaywall />} />
        <Route path="/reflex" element={<ReflexPaywall />} />
        <Route path="/kept" element={<KeptPaywall />} />
        <Route path="/slipstream" element={<SlipstreamPaywall />} />
        <Route path="/safetynet" element={<SafetyNetPaywall />} />
        <Route path="/byheart" element={<ByHeartPaywall />} />
        <Route path="/keystone" element={<KeystonePaywall />} />
        <Route path="/longview" element={<LongviewPaywall />} />
        <Route path="/counterweight" element={<CounterweightPaywall />} />
        <Route path="/keepposted" element={<KeepPostedPaywall />} />
        <Route path="/patchwork" element={<PatchworkPaywall />} />
        <Route path="/evergreen" element={<EvergreenPaywall />} />
        <Route path="/keepsake" element={<KeepsakePaywall />} />
        <Route path="/glyph" element={<GlyphPaywall />} />
        <Route path="/overair" element={<OverairPaywall />} />
        <Route path="/proof" element={<ProofPaywall />} />
        <Route path="/beacon" element={<BeaconPaywall />} />
        <Route path="/mainspring" element={<MainspringPaywall />} />
        <Route path="/amber" element={<AmberPaywall />} />
        <Route path="/sightline" element={<SightlinePaywall />} />
        <Route path="/postmark" element={<PostmarkPaywall />} />
        <Route path="/firstlight" element={<FirstlightPaywall />} />
        <Route path="/closer" element={<CloserPaywall />} />
        <Route path="/cascade" element={<CascadePaywall />} />
        <Route path="/tearline" element={<TearlinePaywall />} />
        <Route path="/handsel" element={<HandselPaywall />} />
        <Route path="/doubles" element={<DoublesPaywall />} />
        <Route path="/homecoming" element={<HomecomingPaywall />} />
        <Route path="/openshutter" element={<OpenShutterPaywall />} />
        <Route path="/fullcircle" element={<FullCirclePaywall />} />
        <Route path="/offscreen" element={<OffscreenPaywall />} />
        <Route path="/failsafe" element={<FailsafePaywall />} />
        <Route path="/carryall" element={<CarryallPaywall />} />
        <Route path="/standby" element={<StandbyPaywall />} />
        <Route path="/perimeter" element={<PerimeterPaywall />} />
        <Route path="/tideline" element={<TidelinePaywall />} />
        <Route path="/once" element={<OncePaywall />} />
        <Route path="/hearth" element={<HearthPaywall />} />
        <Route path="/headroom" element={<HeadroomPaywall />} />
        <Route path="/reel" element={<ReelPaywall />} />
        <Route path="/trove" element={<TrovePaywall />} />
        <Route path="/vista" element={<VistaPaywall />} />
        <Route path="/tumbler" element={<TumblerPaywall />} />
        <Route path="/lifeline" element={<LifelinePaywall />} />
        <Route path="/artifact" element={<ArtifactPaywall />} />
        <Route path="/brink" element={<BrinkPaywall />} />
        <Route path="/aegis" element={<AegisPaywall />} />
        <Route path="/vigil" element={<VigilPaywall />} />
        <Route path="/throughline" element={<ThroughlinePaywall />} />
        <Route path="/album" element={<StickerAlbumPaywall />} />
        <Route path="/flurry" element={<FlurryPaywall />} />
        <Route path="/current" element={<CurrentPaywall />} />
        <Route path="/imprint" element={<ImprintPaywall />} />
        <Route path="/plainsight" element={<PlainSightPaywall />} />
        <Route path="/cipher" element={<CipherPaywall />} />
        <Route path="/onlyyou" element={<OnlyYouPaywall />} />
        <Route path="/hallmark" element={<HallmarkPaywall />} />
        <Route path="/ward" element={<WardPaywall />} />
        <Route path="/rekindle" element={<RekindlePaywall />} />
        <Route path="/static" element={<StaticPaywall />} />
        <Route path="/eyesonly" element={<EyesOnlyPaywall />} />
        <Route path="/safelight" element={<SafelightPaywall />} />
        <Route path="/sanctum" element={<SanctumPaywall />} />
        <Route path="/bystander" element={<BystanderPaywall />} />
        <Route path="/keyline" element={<KeylinePaywall />} />
        <Route path="/seam" element={<SeamPaywall />} />
        <Route path="/flipside" element={<FlipsidePaywall />} />
        <Route path="/nightlatch" element={<NightlatchPaywall />} />
        <Route path="/fold" element={<FoldPaywall />} />
        <Route path="/aperture" element={<AperturePaywall />} />
        <Route path="/facedown" element={<FacedownPaywall />} />
        <Route path="/strongbox" element={<StrongboxPaywall />} />
        <Route path="/trace" element={<TracePaywall />} />
        <Route path="/latent" element={<LatentPaywall />} />
        <Route path="/watermark" element={<WatermarkPaywall />} />
        <Route path="/shade" element={<ShadePaywall />} />
        <Route path="/reissue" element={<ReissuePaywall />} />
        <Route path="/clasp" element={<ClaspPaywall />} />
        <Route path="/sentry" element={<SentryPaywall />} />
        <Route path="/unseen" element={<UnseenPaywall />} />
        <Route path="/twofold" element={<TwofoldPaywall />} />
        <Route path="/handoff" element={<HandoffPaywall />} />
        <Route path="/sealed" element={<SealedPaywall />} />
        <Route path="/cleared" element={<ClearedPaywall />} />
        <Route path="/negative" element={<NegativePaywall />} />
        <Route path="/ink" element={<InkPaywall />} />
        <Route path="/bothkeys" element={<BothKeysPaywall />} />
        <Route path="/lodestone" element={<LodestonePaywall />} />
        <Route path="/mantle" element={<MantlePaywall />} />
        <Route path="/silvered" element={<SilveredPaywall />} />
        <Route path="/airtight" element={<AirtightPaywall />} />
        <Route path="/cradle" element={<CradlePaywall />} />
        <Route path="/reinstate" element={<ReinstatePaywall />} />
        <Route path="/ironclad" element={<IroncladPaywall />} />
        <Route path="/yours" element={<YoursPaywall />} />
        <Route path="/eclipse" element={<EclipsePaywall />} />
        <Route path="/tempered" element={<TemperedPaywall />} />
        <Route path="/signet" element={<SignetPaywall />} />
        <Route path="/tracery" element={<TraceryPaywall />} />
        <Route path="/entrust" element={<EntrustPaywall />} />
        <Route path="/tuck" element={<TuckPaywall />} />
        <Route path="/lantern" element={<LanternPaywall />} />
        <Route path="/locket" element={<LocketPaywall />} />
        <Route path="/halo" element={<HaloPaywall />} />
        <Route path="/solari" element={<SolariPaywall />} />
        <Route path="/everwatch" element={<EverwatchPaywall />} />
        <Route path="/holdfast" element={<HoldfastPaywall />} />
        <Route path="/longhand" element={<LonghandPaywall />} />
        <Route
          path="/onboardingUltimateAlternate"
          element={
            <ConditionalFreeTrialPaywall
              freeTrialPaywall={OnboardingUltimateAlternatePaywall}
            />
          }
        />
      </Routes>
    </SafeAreaInsetPage>
  )
}

export default App
export { preReactInitialData }
